export interface IndustryCodes {
    readonly code: string;
    readonly label: string;
}

const industryCodeNameMap = {
    sic: "SIC",
    naics: "NAICS",
} as const;
export type IndustryCodeName = (typeof industryCodeNameMap)[keyof typeof industryCodeNameMap];

export const industryCodeDtoMap = {
    sic: "sicCodes",
    naics: "naicsCodes",
} as const;
export type IndustryCodeDto = (typeof industryCodeDtoMap)[keyof typeof industryCodeDtoMap];

export const INDUSTRIES_CODE_NAMES: Record<IndustryCodeDto, IndustryCodeName> = {
    [industryCodeDtoMap.naics]: industryCodeNameMap.naics,
    [industryCodeDtoMap.sic]: industryCodeNameMap.sic,
};
